import React, { useState } from 'react';
import { Select } from 'antd';

const { Option } = Select;

const WeekdaySelector = () => {
    const [selectedDays, setSelectedDays] = useState([]);
    
    const handleDayChange = (value) => {
        setSelectedDays(value);
    };
    console.log({selectedDays});
    return (
        <div>
            <Select
                mode="multiple"
                style={{ width: '100%' }}
                placeholder="Selecione os dias da semana"
                onChange={handleDayChange}
                value={selectedDays}
            >
                <Option value="Sunday">Domingo</Option>
                <Option value="Monday">Segunda-feira</Option>
                <Option value="Tuesday">Terça-feira</Option>
                <Option value="Wednesday">Quarta-feira</Option>
                <Option value="Thursday">Quinta-feira</Option>
                <Option value="Friday">Sexta-feira</Option>
                <Option value="Saturday">Sábado</Option>
            </Select>
        </div>
    );
};

export default WeekdaySelector;